<template>
 <div>
   <loading style="margin-top: 200px!important;" v-if="loading"/>
   <div v-else>
     <TopSlider/>

     <div v-scroll-reveal.reset class="text-center mt-8 mb-16" dir="auto">

       <h2  class="font-weight-bold" v-html="info.details ? info.details.site_desc:''"></h2>
     </div>

     <ProductsGrid/>

     <CompanyHint />

     <homeSlider  type="news" :list="this.topicNews.topics" :title="$t('news')" :sub-title="$t('news-subtitle')"/>

     <div v-if="info && info.details" v-html="info.details.sang_khara"  class="text-center my-16" dir="auto">
      
     </div>

     <homeSlider v-if="catalogue.topics" type="catalogue" :list="catalogue.topics.slice(0,3)" :title="$t('download')" :sub-title="$t('download-subtitle')"/>

     <AboutCompany/>

   </div>
 </div>
</template>

<script>
import ProductsGrid from "./components/ProductsGrid";
import CompanyHint from "./components/CompanyHint";
import AboutCompany from "./components/AboutCompany";
import TopSlider from "./components/TopSlider";
import {GET_NEWS} from "../../store/newsManagement/action_types";
import {mapState} from "vuex";
import {GET_GRID, GET_HINT, GET_SLIDER, GET_TOPIC_NEWS, GET_WHY} from "../../store/homeManagement/action_types";
import {GET_INFO} from "../../store/infoManagement/action_types";
import {GET_CATALOGUE} from "../../store/eventManagement/action_types";

export default {
  name: 'Home',
  components: {TopSlider, CompanyHint, ProductsGrid, AboutCompany},
  data() {
    return {
      offset: 0,


    }
  },
  created() {
    console.log(this.$i18n,this.$i18n.locale)
    
    this.$store.dispatch(`homeManagement/${GET_WHY}`);
    this.$store.dispatch(`homeManagement/${GET_SLIDER}`);
    this.$store.dispatch(`homeManagement/${GET_GRID}`);
    this.$store.dispatch(`homeManagement/${GET_HINT}`);
    this.$store.dispatch(`homeManagement/${GET_TOPIC_NEWS}`);
    this.$store.dispatch(`eventManagement/${GET_CATALOGUE}`);
    this.$store.dispatch(`infoManagement/${GET_INFO}`);
    if(localStorage.getItem("lang")){
      this.$i18n.locale=localStorage.getItem("lang")
    }
  },
  computed: {
    ...mapState({
      loading: state => state.homeManagement.loading,
      info: state => state.infoManagement.info,
      topicNews: state => state.homeManagement.topicNews,
      catalogue: state => state.eventManagement.event,

    })
  },

}
</script>
<style scoped>
section {
  height: 100vh;
}
</style>
